import React from 'react';
import styles from './WhatsAppFloat.module.css';

const WhatsAppFloat: React.FC = () => {
  const handleClick = () => {
    window.open('https://wa.me/34610136033', '_blank');
  };

  return (
    <button
      className={styles.floatingButton}
      onClick={handleClick}
      aria-label="Contact us on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
      >
        <path
          fill="currentColor"
          d="M16 0C7.164 0 0 7.164 0 16c0 2.825.736 5.479 2.02 7.782L0 32l8.448-2.008A15.935 15.935 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.455c-2.512 0-4.875-.689-6.895-1.885l-.494-.292-5.13 1.22 1.228-5.039-.322-.512A13.386 13.386 0 0 1 2.545 16C2.545 8.567 8.567 2.545 16 2.545S29.455 8.567 29.455 16 23.433 29.455 16 29.455z"
        />
        <path
          fill="currentColor"
          d="M23.516 19.467c-.388-.194-2.3-1.135-2.657-1.264-.356-.129-.615-.194-.875.194-.259.388-1.004 1.264-1.231 1.523-.227.259-.453.291-.841.097-.388-.194-1.637-.603-3.117-1.923-1.152-1.027-1.931-2.297-2.158-2.685-.227-.388-.024-.598.17-.791.175-.174.388-.453.582-.679.194-.227.259-.388.388-.647.129-.259.065-.485-.032-.679-.097-.194-.875-2.108-1.199-2.886-.316-.757-.637-.654-.875-.666-.227-.011-.485-.013-.744-.013s-.682.097-1.039.485c-.356.388-1.361 1.329-1.361 3.243s1.393 3.762 1.587 4.021c.194.259 2.739 4.182 6.636 5.863.928.4 1.652.639 2.217.818.931.296 1.779.254 2.448.154.747-.112 2.3-.941 2.624-1.849.324-.908.324-1.685.227-1.849-.097-.164-.356-.259-.744-.453z"
        />
      </svg>
    </button>
  );
};

export default WhatsAppFloat;

